export function getConfigField(name: string) {
  const field = name?.split(' ')[0];

  return field;
}
